import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-navy-deep" data-id="element-111" data-mp="1o3dmwcdeadr5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-112" data-mp="2223ljwfv4lhm">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-turf bg-turf/15 text-white" data-id="element-113" data-mp="1x42054uysa2z">
          <span className="font-display text-4xl font-bold leading-none" data-id="element-114" data-mp="19co8700q6gij">7</span>
          <span className="font-display text-xs font-bold uppercase tracking-widest" data-id="element-115" data-mp="14h8vwcid8so8">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-116" data-mp="1j5v9o9schcdc">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-117" data-mp="1ecizh4oex844">
          Run your next practice from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/80" data-id="element-118" data-mp="lodd6dhpnb26">
          Open Volume 1, print Day One and run it with your team. Try the Season
          Map, the Practice Finder and the talk cards. If No-Lines Lacrosse
          doesn&apos;t make your practices easier to plan and run, email us
          inside 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-119" data-mp="12rg04e2dd2gs">
          {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-4 py-2 text-[13px] text-white/75" data-id="element-120" data-mp="616z8pdpbkpc">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}